type Dated = { is_pinned?: boolean; updated_at?: string; created_at?: string }

/** 最近对话按时间分组：置顶、今天、昨天、近 7 天、近 30 天、更早。 */
export function groupSessions<T extends Dated>(sessions: T[], now = new Date()): { label: string; items: T[] }[] {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  const day = 86_400_000
  const groups: [string, (t: number) => boolean][] = [
    ['今天', (t) => t >= start],
    ['昨天', (t) => t >= start - day],
    ['近 7 天', (t) => t >= start - 6 * day],
    ['近 30 天', (t) => t >= start - 29 * day],
    ['更早', () => true],
  ]
  const out = new Map<string, T[]>()
  const pinned = sessions.filter((s) => s.is_pinned)
  if (pinned.length) out.set('置顶', pinned)
  for (const s of sessions) {
    if (s.is_pinned) continue
    const t = new Date(s.updated_at || s.created_at || 0).getTime()
    const label = groups.find(([, test]) => test(Number.isFinite(t) ? t : 0))![0]
    out.set(label, [...(out.get(label) ?? []), s])
  }
  return [...out].map(([label, items]) => ({ label, items }))
}
